import {RestHttpService} from "@catcore/services/rest-http.service";
import {Restangular} from "ngx-restangular";
import {Observable} from "rxjs";
import {StatusInfo} from "@catfeatures/types";
import {PlaylistCreateInfo} from "@catmodels/avod-catalog/types";

export class PlaylistService extends RestHttpService<StatusInfo> {

  constructor(href: string,
              service: Restangular) {
    super(href, service);
  }

  create(item: PlaylistCreateInfo): Observable<any> {
    const payload = {
      avod_catalog: item.avod_catalog._links.self.href,
      name: item.name,
      path: item.path,
      sync_with_settings: item.syncWithSettings,
    }

    return this.add(payload)
      .map((createdModel) => {
        return createdModel;
      });
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/models/avod-catalog/services/playlist.service.ts